






















  import { getQuestionById, Simulation } from '@/api/custom-simulation';
import { safeJsonParse } from '@/utils/safe-json-parse';
import Vue from 'vue';
import QuestionItem from './QuestionItem.vue';
import AnswerInfoModal from './AnswerInfoModal.vue';

  export default Vue.extend({
    data() {
        return {
            questions: [] as {id: string;name: string;viewSettings: string;classType: number;standAnswerArray: string}[],
            selected: {} as Record<string, string[]>,
              wrongIds: [] as string[],
              showAnswer: false as boolean,
              answerInfoModalVisible: false as boolean,
              hidden: false as boolean
        };
    },
    computed: {
      correctNum(): number {
        return ((this.questionIds?.length || 0) - (this.wrongIds.length || 0)) || 0;
      },
        questionIds(): string[] {
            return safeJsonParse(this.$store.state.customSimulationModule.selectedSimulationDetail.viewSettings || '[]');
        },
        selectedSimulationDetailId(): string {
          return this.$store.state.customSimulationModule.selectedSimulationDetail.id;
        },
        selectedSimulationDetail(): any {
          return this.$store.state.customSimulationModule.selectedSimulationDetail;
        },
        currentSimulation(): Simulation {
            return this.$store.state.customSimulationModule.currentSimulation;
        },
        isFinished(): boolean {
          return this.selectedSimulationDetail.sort === this.currentSimulation.step + 2;
        }
    },
    watch: {
        questionIds: {
            handler() {
                this.init();
            },
            deep: true
        }
    },
    methods: {
      getSelectedAnswer(id) {
        return this.selected[id];
      },
        async init() {
            const res: any = await getQuestionById({ ids: this.questionIds });
            if (res.success) {
                this.questions = res.data;
                res.data.forEach(v => {
                  this.selected[v.id] = [];
                });
                this.wrongIds = [];
                this.showAnswer = false;
                this.answerInfoModalVisible = false;
                if (!this.questions.length) {
                  this.hidden = true;
                } else {
                  this.hidden = false;
                }
            } else {
              console.log('fail');
            }
        },
        handleSelect(data) {
          if (!this.showAnswer) {
            this.selected[data.id] = data.selected;
          }
        },
        submitQuestion() {
          if (!this.questionIds.every(v => this.selected[v].length)) {
            this.$message.warning('请先作答');
            return;
          }
          const wrongId: string[] = [];
          this.questions.forEach(v => {
            if (v.standAnswerArray !== JSON.stringify(this.selected[v.id])) {
              wrongId.push(v.id);
            }
          });
          this.wrongIds = wrongId;
          this.answerInfoModalVisible = true;
          this.showAnswer = true;
        },
        getOption(val): {
            value: string;
            label: string;
        }[] {
            return safeJsonParse(val);
        }
    },
    mounted() {
        this.init();
    },
    components: { QuestionItem, AnswerInfoModal }
});
